/**
 * EmptyState — shown when a list query succeeds but returns zero rows.
 *
 * Spec: PORTAL_MIGRATION_FROM_PSM_SSOT.md §4.1.2 (Phase 1 foundation).
 * Distinct from ErrorState (which is for failed queries / disabled
 * features). The optional `action` slot accepts a Button or Link.
 */
import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  /** Optional secondary text. Keep short (one sentence). */
  description?: ReactNode;
  /** Optional CTA — typically a `<Button>` or `<Link>`. */
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps): JSX.Element {
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        padding: '2.5rem 1.5rem',
        textAlign: 'center',
        color: '#374151',
        background: '#fff',
        border: '1px dashed #d1d5db',
        borderRadius: '0.5rem',
      }}
    >
      <p style={{ margin: 0, fontWeight: 600, color: '#111827' }}>{title}</p>
      {description ? (
        <p style={{ margin: 0, fontSize: '0.875rem', color: '#4b5563' }}>{description}</p>
      ) : null}
      {action ? <div style={{ marginTop: '0.5rem' }}>{action}</div> : null}
    </div>
  );
}
